<!------------ START TEMPLATE ------------>
<template>
  <div v-if="relacionamento">
    <vs-list>
      <vs-list-item icon="date_range" title="Data de criação">
        <p>{{ formataData(relacionamento.createdAt) }}</p>
      </vs-list-item>
      <vs-list-item icon="help" title="Tipo de Solicitação">
        <p>{{ relacionamento.tipoSolicitacao.tipoRelacionamento }}</p>
      </vs-list-item>
      <vs-list-item icon="apartment" title="Aberto pelo setor ">
        <p>{{ relacionamento.setor.nomeSetor }}</p>
      </vs-list-item>
      <vs-list-item icon="thumbs_up_down" title="Status">
        <p>{{ relacionamento.statusRelacionamento.statusRelacionamento }}</p>
      </vs-list-item>
      <vs-list-item icon="person" title="Beneficiário">
        <p>{{ relacionamento.associado.nome }}</p>
      </vs-list-item>
      <vs-list-item icon="record_voice_over" title="Quem solicitou">
        <p>{{ relacionamento.solicitante }}</p>
      </vs-list-item>
      <vs-list-item
        v-if="relacionamento.idVeiculo"
        icon="directions_car"
        title="Veículo"
      >
        <p>{{ dadosVeiculo.placaChassi }}</p>
      </vs-list-item>
      <vs-list-item icon="subject" title="Assunto">
        <p>{{ relacionamento.assunto }}</p>
      </vs-list-item>
      <vs-list-item
        icon="forum"
        title="Desc. do Atendimento"
        style="overflow: auto"
      >
        <p style="padding-left: 10%">
          {{ relacionamento.descricaoSolicitacao }}
        </p>
      </vs-list-item>

      <vs-list-item
        v-if="relacionamento.Relacionamento_Anexos.length"
        icon="attachment"
        :title="
          'Anexo' + (relacionamento.Relacionamento_Anexos.length > 1 ? 's' : '')
        "
      >
        <div
          v-for="anexo in relacionamento.Relacionamento_Anexos"
          :key="anexo.idRelacionamentoAnexo"
        >
          <a :href="anexo.url" target="_blank">
            {{ anexo.url.substr(anexo.url.lastIndexOf('/') + 15) }}
          </a>
        </div>
      </vs-list-item>
    </vs-list>
    <hr v-if="relacionamento.Relacionamento_Atendimentos.length" class="my-2" />
    <vs-list v-if="relacionamento.Relacionamento_Atendimentos.length">
      <vs-list-header
        title="Registros do Atendimento"
        color="gray"
      ></vs-list-header>
      <vs-list
        v-for="atendimento in ordernaAtendimentos(
          relacionamento.Relacionamento_Atendimentos,
        )"
        :key="atendimento.idAtendimento"
      >
        <vs-card>
          <vs-list-item icon="date_range" title="Data de criação">
            <p>
              {{ formataData(atendimento.createdAt) }}
            </p>
          </vs-list-item>

          <vs-list-item icon="person" title="Solicitante">
            <p>{{ atendimento.solicitante }}</p>
          </vs-list-item>

          <vs-list-item
            icon="forum"
            title="Desc. do Atendimento"
            style="overflow: auto"
          >
            <div style="padding-left: 10%">
              {{ atendimento.descricaoAtendimento }}
            </div>
          </vs-list-item>
        </vs-card>
      </vs-list>
    </vs-list>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['relacionamento', 'dadosVeiculo'],
  data() {
    return {
      relacionamentoAtendimentos: [],
    };
  },
  methods: {
    ordernaAtendimentos(atendimentos) {
      var list = [...atendimentos];
      return list.reverse();
    },
    getStatusColorHoras(status, date) {
      var a = moment();
      var horas = a.diff(date, 'hours');
      if (horas < 10) return 'success';
      if (horas >= 10 && horas <= 24) return 'warning';
      if (horas > 24) return 'danger';
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    formataDataUTC(data) {
      return moment(data).utc().format('DD/MM/YYYY HH:mm');
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style lang="scss"></style>
